import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class BuyersOrderReportService {
  constructor(private http: HttpUtilService) {}

}
